import { addCommas } from "@domains/utils/numberMethods";
import GenericTable from "@frameworks/web/components/generic/GenericTable";
import React from "react";
import { Col } from "react-bootstrap";
const Charges = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    let ChargesRows = [
        {
            Turnover: "Brokerage",
            price: (_a = props === null || props === void 0 ? void 0 : props.charges) === null || _a === void 0 ? void 0 : _a.brokerage,
        },
        {
            Turnover: "Transaction Charges",
            price: (_b = props === null || props === void 0 ? void 0 : props.charges) === null || _b === void 0 ? void 0 : _b.transactionCharge,
        },
        {
            Turnover: "Stamp Duty ",
            price: (_c = props === null || props === void 0 ? void 0 : props.charges) === null || _c === void 0 ? void 0 : _c.stampDutyCharge,
        },
        {
            Turnover: "SEBI Turnover Charges",
            price: (_d = props === null || props === void 0 ? void 0 : props.charges) === null || _d === void 0 ? void 0 : _d.sebiTurnoverCharge,
        },
        {
            Turnover: "Securities Transaction Tax",
            price: (_e = props === null || props === void 0 ? void 0 : props.charges) === null || _e === void 0 ? void 0 : _e.stt,
        },
        {
            Turnover: "GST",
            price: (_f = props === null || props === void 0 ? void 0 : props.charges) === null || _f === void 0 ? void 0 : _f.gst,
        },
        {
            Turnover: "Clearing Charge",
            price: (_g = props === null || props === void 0 ? void 0 : props.charges) === null || _g === void 0 ? void 0 : _g.clearingCharge,
        },
        {
            Turnover: "Total Charges",
            price: (_h = props === null || props === void 0 ? void 0 : props.charges) === null || _h === void 0 ? void 0 : _h.totalCharge,
        },
    ];
    let ChargesColumn = [
        {
            columnName: "Turnover",
            arrows: false,
            key: "Turnover",
        },
        {
            columnName: addCommas((_j = props === null || props === void 0 ? void 0 : props.charges) === null || _j === void 0 ? void 0 : _j.turnover, true),
            arrows: false,
            key: "price",
            columnClassName: "px-md-0 text-end",
            tdCustomFunction: (key) => {
                return addCommas(key, true);
            },
        },
    ];
    return (React.createElement(React.Fragment, null,
        React.createElement(Col, { lg: 12, className: "px-md-4 px-0" },
            React.createElement(GenericTable, { columns: ChargesColumn, parentClassName: "charges-table table", data: ChargesRows }))));
};
export default Charges;
